import React, { useEffect } from 'react';

import { DefaultCommandProps, Constraint } from './index';

import Base from './base';

const validateValue = (
  value: number,
  constraints: Constraint[],
  setError: (value: boolean) => void,
  setHelperText: (value: string) => void
) => {
  let error = false;

  constraints.forEach((constraint) => {
    switch (constraint.key) {
      case 'min':
        if (value < Number(constraint.value)) {
          error = true;
          setHelperText(`Value should be greater than or equal to ${constraint.value}`);
        }
        break;
      case 'max':
        if (value > Number(constraint.value)) {
          error = true;
          setHelperText(`Value should be less than or equal to ${constraint.value}`);
        }
        break;
      default:
        break;
    }
  });

  if (!error) {
    setError(false);
    setHelperText('');
  } else {
    setError(true);
  }
};

const IntegerInput = ({
  constraints,
  label,
  onChange,
  setInputsError,
  value,
}: DefaultCommandProps) => {
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState('');

  const handleChange = (data: string) => {
    onChange(label, Number(data));

    if (constraints?.length) {
      validateValue(Number(data), constraints, setError, setHelperText);
    }
  };

  useEffect(() => {
    setInputsError(error);
  }, [error, setInputsError]);

  return (
    <Base
      error={error}
      helperText={helperText}
      id={label}
      onChange={handleChange}
      type="number"
      value={value}
    />
  );
};

export default IntegerInput;
